module.exports = __webpack_public_path__ + "static/media/points-icon-battles-large.469f5ba8.png";